import customCss from "./customCss";
import markdownRenderer from "./markdownRenderer";

import handlePartialSend from "../form_events/handlePartialSend";
import handleComplete from "../form_events/handleComplete";
import handleAfterRenderQuestion from "../form_events/handleAfterRenderQuestion";
import handleDropdownLazyLoad from "../form_events/handleDropdownLazyLoad";

export default (survey, config) => {
  try {
    applyInitialSetup(survey, config);
    setupEventHandlers(survey, config);
  } catch (error) {
    console.error("Error in survey setup:", error);
  }
};

function applyInitialSetup(survey, config) {
  survey.css = customCss;
  survey.showProgressBar = false;
  survey.sendResultOnPageNext = true;

  if (isDealStage(config.defaultResponse)) {
    survey.css = {
      ...customCss,
      completedPage: "w-full mt-8 p-0 max-w-none bg-transparent rounded-none",
    };
    survey.completedHtml = generateDealCompletedHtml();
  }

  applyResponseData(survey, config.responseData);
  markdownRenderer(survey);
}

function setupEventHandlers(survey, config) {
  survey.onPartialSend.add(() => handlePartialSend(survey, config));
  survey.onComplete.add(() => handleComplete(survey, config));
  survey.onAfterRenderQuestion.add((survey, options) =>
    handleAfterRenderQuestion(survey, options, config)
  );
  survey.onChoicesLazyLoad.add(handleDropdownLazyLoad);

  const reviewPageContainer = document.querySelector(".review-content");
  if (reviewPageContainer) {
    survey.onAfterRenderPage.add((survey) => {
      updateCompleteButtonState(survey);
    });
  }
}

function updateCompleteButtonState(survey) {
  const completeButton = document.querySelector('#sv-nav-complete input[type="button"]');
  if (!completeButton) {
    return;
  }

  const hasErrors = survey.visiblePages.some(page => page.hasErrors(false));

  if (hasErrors) {
    completeButton.disabled = true;
    completeButton.classList.add('text-gray-800', 'bg-gray-300', 'disabled:pointer-events-none');
    completeButton.classList.remove('hover:bg-forest-600', 'hover:light:bg-navy-600');
  } else {
    completeButton.disabled = false;
    completeButton.classList.remove('text-gray-800', 'bg-gray-300', 'disabled:pointer-events-none');
    completeButton.classList.add('hover:bg-forest-600', 'hover:light:bg-navy-600');
  }
}

function isDealStage(defaultResponse) {
  if (defaultResponse !== undefined && defaultResponse !== null) {
    return defaultResponse["dashboard_stage"] == "deal";
  } else {
    return false;
  }
}

function applyResponseData(survey, responseData) {
  if (responseData && Object.keys(responseData).length > 0) {
    survey.data = responseData;
    if (responseData.pageNo !== undefined) {
      survey.currentPageNo = responseData.pageNo;
    }
  }
}

function generateDealCompletedHtml() {
  const dashboardPath = window.location.href.replace("form", "home");
  const bodyTextClasses = "text-sm text-forest-700";

  return `
    <div class="w-full text-left">
      <div class="flex w-full flex-col gap-4 rounded-md bg-white px-6 py-8 text-forest-700 md:px-8">
        <h3 class="text-xl2 text-forest-700">Thank you for completing your paperwork ahead of time</h3>
        <p class="${bodyTextClasses}">
          This will save you time when your loved one passes. At that time we will ask you
          to return to your dashboard to review your answers and provide additional information
          on the passing.
        </p>
        <p class="${bodyTextClasses}">
          We are here to support you and your family throughout this time, so please don't hesitate
          to call or email if you have any questions.
        </p>
        <p class="${bodyTextClasses}">
          For now, you can click on the button below to return to your dashboard.
        </p>
        <div class="mt-2 flex w-full justify-end">
          <a
            href="${dashboardPath}"
            class="inline-flex w-fit items-center justify-center gap-1 rounded-full bg-forest-500 px-6 py-3.5 text-sm font-bold text-white transition duration-300 ease-in-out hover:bg-mint-500 hover:text-forest-500 light:bg-navy-700 light:hover:bg-navy-600 light:hover:text-white"
          >
            Return to Dashboard
            <span aria-hidden="true" class="ml-0.5 leading-none">></span>
          </a>
        </div>
      </div>
    </div>
    `;
}
